var exports = {
  "kL": "xa15a2ab7--be724d--container",
  "Qq": "xa15a2ab7--be724d--text",
  "Kk": "xa15a2ab7--be724d--icon",
  "Rm": "xa15a2ab7--be724d--secondary",
};

module.exports = exports;
